import { serverFetch as baseServerFetch } from '@core/server';

const apiBaseUrl = process.env.REACT_APP_FLP_API_BASE_URL;

export async function serverFetch(address, options, signal) {
    return baseServerFetch(apiBaseUrl, undefined, address, options, signal);
}
